module.exports = "/images/1.jpg?61ad1010c0d78c099a547c1a7739b420";